import i18n from 'i18n';
import {
  ColDef,
} from '@ag-grid-community/core';
import decodeContactValue from './utils/decodeContactValue';

export enum CspConfigMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view',
}

/**
 * This value must be set in common-grid columnDefsVersion property. So, updating this value
 * forces common-grid to use the in code columnDefs instead of the saved grid setting.
 */
export const cspConfigColumnDefsVersion = '4';

export const cspConfigColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('cspConfig.grid.name'),
    field: 'name',
    tooltipField: 'name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 200,
  },
  {
    headerName: i18n.t('cspConfig.grid.cspId'),
    field: 'cspid',
    tooltipField: 'cspid',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 160,
  },
  {
    headerName: i18n.t('cspConfig.grid.legalContact'),
    field: 'legalcontact',
    // These two columns hold a contact id, so they are shown decoded - see
    // decodeContactValue. A valueGetter rather than a valueFormatter, so the sort and the
    // text filter work on the name the user can actually see.
    valueGetter: ({ data }) => decodeContactValue(data?.legalcontact),
    tooltipValueGetter: ({ data }) => decodeContactValue(data?.legalcontact),
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 160,
  },
  {
    headerName: i18n.t('cspConfig.grid.nwContact'),
    field: 'nwcontact',
    valueGetter: ({ data }) => decodeContactValue(data?.nwcontact),
    tooltipValueGetter: ({ data }) => decodeContactValue(data?.nwcontact),
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 160,
  },
];
